(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6419,7765],{

/***/ 38420:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/author/[id]/[slug]",
      function () {
        return __webpack_require__(83874);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/components/layout/components/Footer.tsx + 3 modules
var Footer = __webpack_require__(56096);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/components/metadata/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(37066);
// EXTERNAL MODULE: ./src/components/navbar/Navbar.tsx + 2 modules
var Navbar = __webpack_require__(43117);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/page-components/books/MasterBookAuthorPage.tsx














var BOOK_SIZE = {
    WIDTH: 180,
    HEIGHT: 260
};
var IMAGE_SIZE = 240;
var DEFAULT_AUTHOR_IMAGE = "https://static.deepstash.com/images/author-placeholder.png";
var MasterBookAuthorPage = function(param) {
    var publisher = param.publisher, pageMetadata = param.pageMetadata;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var isIos = (0,esm.useDeviceDetect)().isIos;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), descriptionExpanded = ref[0], setDescriptionExpanded = ref[1];
    var dividerLine = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        height: 2,
        bgColor: esm.color[colorMode].underground,
        width: "100%"
    });
    var mobileAppSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "column",
            mt: "2rem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    type: "semiBold",
                    color: esm.color[colorMode].textSecondary,
                    size: "l",
                    children: "Read top ideas, quotes & summaries from ".concat(publisher.name, " books, with the Deepstash App.")
                }),
                isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.AppStoreButton, {
                    w: "100%",
                    store: isIos ? "Apple" : "GooglePlay"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    gridColumnGap: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.AppStoreButton, {
                            w: esm.spacing.toRem(192),
                            h: esm.spacing.toRem(48),
                            store: "Apple"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.AppStoreButton, {
                            w: esm.spacing.toRem(192),
                            h: esm.spacing.toRem(48),
                            store: "GooglePlay"
                        })
                    ]
                })
            ]
        })
    });
    var _image;
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
        wrapperStyle: {
            width: IMAGE_SIZE,
            height: IMAGE_SIZE,
            borderRadius: IMAGE_SIZE,
            cursor: "default"
        },
        imageUrl: (_image = publisher.image) !== null && _image !== void 0 ? _image : DEFAULT_AUTHOR_IMAGE,
        alt: publisher.name,
        blurhash: publisher.image_blurhash,
        priority: true
    });
    var _description;
    var descriptionSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        mt: 32,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDirection: "row",
                justifyContent: "space-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    type: "semiBold",
                    color: esm.color[colorMode].textSecondary,
                    size: "l",
                    children: "About the author (not Wikipedia but close)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                size: "m",
                color: esm.color[colorMode].textSecondary,
                noOfLines: descriptionExpanded ? undefined : 3,
                children: (_description = publisher.description) !== null && _description !== void 0 ? _description : "".concat(publisher.name, " is an accomplished writer whose work has resonated with readers around the world. ").concat(publisher.name, " has published several books that explore a range of topics, from fiction to nonfiction, and has received critical acclaim for the ability to weave compelling narratives. ").concat(publisher.name, "'s writing style is known for its depth and authenticity, and has earned quite a loyal following of readers.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                _hover: {
                    cursor: "pointer"
                },
                color: esm.color[colorMode].text,
                onClick: function() {
                    setDescriptionExpanded(function(prevValue) {
                        return !prevValue;
                    });
                },
                children: descriptionExpanded ? "See Less" : "Read full Bio"
            })
        ]
    });
    var renderBookImageComponent = function(param) {
        var book = param.book, bookPageRoute = param.bookPageRoute;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
            wrapperStyle: {
                width: BOOK_SIZE.WIDTH,
                height: BOOK_SIZE.HEIGHT
            },
            imageUrl: book.image,
            alt: "".concat(publisher.name, " Books"),
            blurhash: book.image_blurhash,
            priority: true,
            onClick: function() {
                router.push(bookPageRoute);
            }
        });
    };
    var renderBooksSection = function() {
        var ref;
        if (publisher.top_sources === undefined || ((ref = publisher.top_sources) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            flexDirection: "column",
            mt: 24,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    color: esm.color[colorMode].textSecondary,
                    size: "h2"
                }, esm.typography.primaryHeadingFonts.small.semiBold), {
                    children: "".concat(publisher.name, " Books & Quotes")
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    overflowX: "scroll",
                    flexWrap: "nowrap",
                    gridGap: 32,
                    mt: 16,
                    pb: 32,
                    children: publisher.top_sources.map(function(book, index) {
                        var bookSlug = (0,global/* slugify */.lV)(book.title);
                        var bookPageRoute = "/book/".concat(book.id, "/").concat(bookSlug);
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            flexDirection: "column",
                            gridRowGap: 16,
                            children: [
                                renderBookImageComponent({
                                    book: book,
                                    bookPageRoute: bookPageRoute
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    href: bookPageRoute,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                        _focus: undefined,
                                        _hover: undefined,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            textAlign: "center",
                                            color: esm.color[colorMode].text,
                                            size: "h3",
                                            width: BOOK_SIZE.WIDTH,
                                            overflowX: "hidden"
                                        }, esm.typography.primaryTextFonts.medium.regular), {
                                            children: "".concat(book.title, " Book Summary")
                                        }))
                                    })
                                }, "book-".concat(index))
                            ]
                        }, "book-".concat(index));
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                pageMetadata: pageMetadata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                py: global/* GAP_SIZE_REM */.L3,
                containerProps: {
                    flexDirection: isMobileView ? "column" : "row",
                    gridGap: global/* GAP_SIZE_REM */.L3
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        justifyContent: "flex-start",
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            imageComponent,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                type: "regular",
                                color: esm.color[colorMode].textSecondary,
                                size: "m",
                                mt: esm.spacing.M.rem,
                                children: "Read & browse all books, key ideas and summaries from the book author ".concat(publisher.name, " in just 5 minutes.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        overflowX: "hidden",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                type: "semiBold",
                                color: esm.color[colorMode].textSecondary,
                                size: "l",
                                children: "The best ".concat(publisher.name, " books, summaries, wiki, quotes & more")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, {
                                textSize: "l",
                                type: "bold",
                                size: "h1",
                                color: esm.color[colorMode].text,
                                mt: esm.spacing.M.rem,
                                children: publisher.name
                            }),
                            descriptionSection,
                            mobileAppSection,
                            dividerLine,
                            renderBooksSection()
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var books_MasterBookAuthorPage = (MasterBookAuthorPage);

// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
;// CONCATENATED MODULE: ./pages/book/author/[id]/[slug].tsx








var BookDynamicPage = function(param) {
    var publisher = param.publisher;
    var router = (0,useRouter/* default */.Z)();
    (0,react.useEffect)(function() {
        if (publisher) {
            var _query = router.query, utm_source = _query.utm_source, utm_medium = _query.utm_medium;
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.consumption.viewBookAuthorPage */.z.consumption.viewBookAuthorPage,
                properties: (0,_object_spread/* default */.Z)({
                    publisherId: publisher.id,
                    name: publisher.name
                }, typeof utm_source === "string" ? {
                    utm_source: utm_source
                } : {}, typeof utm_medium === "string" ? {
                    utm_medium: utm_medium
                } : {}),
                platforms: [
                    "amplitude"
                ]
            });
        }
    }, [
        publisher
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(books_MasterBookAuthorPage, {
        publisher: publisher,
        pageMetadata: (0,metadata_utils/* getBookAuthorPageMetadata */.Jp)({
            publisher: publisher
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (BookDynamicPage);


/***/ }),

/***/ 35905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MENU_OPTIONS": function() { return /* binding */ MENU_OPTIONS; },
  "OWNER_OPTIONS": function() { return /* binding */ OWNER_OPTIONS; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/source/source-preview/SourcePreview.tsx + 2 modules
var SourcePreview = __webpack_require__(34549);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/chips/Chip.tsx
var Chip = __webpack_require__(34001);
// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
;// CONCATENATED MODULE: ./src/page-components/search/components/HashtagSearchedResultMobile.tsx







var HashtagSearchedResultDesktop = function(param) {
    var searchedHashtag = param.searchedHashtag;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var _sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDir: "column",
        align: "flex-start",
        mb: global/* BLOCK_WIDTH_REM */.sC,
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                alignItems: "center",
                gridGap: esm.spacing.M.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        content: "#" + searchedHashtag.name,
                        href: "topic/".concat(searchedHashtag.name),
                        m: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, {
                        fontSize: "0.8em",
                        color: esm.color[colorMode].textDisabled,
                        children: [
                            (0,global/* numberFormatter */.V2)(searchedHashtag.totalIdeas),
                            " ",
                            (0,StringUtils/* getSingularOrPlural */.Lo)(searchedHashtag.totalIdeas, "idea", "ideas")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mt: global/* GAP_SIZE_REM */.L3,
                gridGap: global/* GAP_SIZE_REM */.L3,
                width: "100%",
                overflow: {
                    base: "scroll",
                    md: "hidden"
                },
                children: ((_sources = searchedHashtag.sources) !== null && _sources !== void 0 ? _sources : []).slice(0, 4).map(function(source) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                        size: "small",
                        source: source
                    }, source.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HashtagSearchedResultMobile = (HashtagSearchedResultDesktop);

// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/components/social/ProfilePicture.tsx
var ProfilePicture = __webpack_require__(7877);
// EXTERNAL MODULE: ./src/components/buttons/FollowUserButton.tsx + 1 modules
var FollowUserButton = __webpack_require__(97360);
;// CONCATENATED MODULE: ./src/page-components/search/components/UserInfo.tsx








var UserInfo = function(param) {
    var user = param.user, index = param.index;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var profile = (0,useProfile/* default */.Z)().profile;
    var _bio;
    var bioFragments = (0,react.useMemo)(function() {
        return (0,StringUtils/* fragmentTextWithEmojis */.CO)((_bio = user.bio) !== null && _bio !== void 0 ? _bio : "");
    }, [
        user
    ]);
    if (!user) return null;
    var _photo;
    var displayUser = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        _focus: undefined,
        _active: undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePicture/* default */.Z, {
                m: esm.spacing.toRem(2),
                photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                size: "l",
                imageBlurhash: user.photo_blurhash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                ml: "8px",
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        fontSize: "16px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        color: esm.color[colorMode].primary,
                        _hover: {
                            textDecoration: "underline"
                        },
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: "@" + user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        color: esm.color[colorMode].textSecondary,
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: !!user.firstName || !!user.lastName ? "".concat(user.firstName, " ").concat(user.lastName) : user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        textAlign: "center",
                        w: "100%",
                        children: bioFragments.map(function(fragment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "s",
                                color: esm.color[colorMode].textDisabled,
                                textOverflow: "ellipsis",
                                noOfLines: 1,
                                children: fragment
                            }, fragment);
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        bgColor: esm.color[colorMode].top,
        p: esm.spacing.toRem(16),
        borderRadius: esm.spacing.toRem(20),
        mb: esm.spacing.toRem(12),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            justifyContent: "space-between",
            alignItems: "start",
            _focus: undefined,
            _active: undefined,
            wordBreak: "break-all",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/u/".concat(user.username),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        w: "100%",
                        _focus: undefined,
                        _active: undefined,
                        _hover: undefined,
                        children: displayUser
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowUserButton/* default */.Z, {
                    display: (profile === null || profile === void 0 ? void 0 : profile.id) === user.id ? "none" : "inline-flex",
                    userId: user.id,
                    size: "sm",
                    px: esm.spacing.toRem(12),
                    py: esm.spacing.toRem(6)
                })
            ]
        })
    }, index);
};
/* harmony default export */ var components_UserInfo = (UserInfo);

;// CONCATENATED MODULE: ./src/page-components/search/SearchPage.tsx









var SearchPageMobile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9283).then(__webpack_require__.bind(__webpack_require__, 19283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19283)
            ];
        }
    }
});
var SearchPageDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9891), __webpack_require__.e(9834), __webpack_require__.e(2853), __webpack_require__.e(1425), __webpack_require__.e(7436)]).then(__webpack_require__.bind(__webpack_require__, 16171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16171)
            ];
        }
    }
});
SearchPageDesktop.displayName = "SearchPageDesktop";
SearchPageMobile.displayName = "SearchPageMobile";
var SearchPage = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    var isMobileView = (0,esm.useIsMobileView)();
    /**
   * Render the search results
   * @param feed The results to be rendered
   * @param isFetching Whether or not we are currently fetching more results
   * @param searchType What we are searching for
   * @param errorMessage A component to be shown if no results were found
   */ var renderFeed = (0,react.useCallback)(function(feed, isFetching, searchType, errorMessage) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm.Box, {
            children: !isFetching && (!feed || feed.length === 0) ? errorMessage : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                children: [
                    searchType === "article" && feed.map(function(source) {
                        if ((0,global/* isSourceEmpty */.dq)(source)) return null;
                        if (searchType === "article") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                                    source: source,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, "articleCard$".concat(source.id));
                        }
                        return null;
                    }),
                    searchType === "block" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        flexDir: "column",
                        width: "100%",
                        alignItems: "center",
                        children: feed === null || feed === void 0 ? void 0 : feed.map(function(idea) {
                            var source = idea.source;
                            if (!source || (0,global/* isSourceEmpty */.dq)(source)) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePreview/* default */.Z, {
                                    source: source,
                                    ideaId: idea.id,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, source.id);
                        })
                    }),
                    searchType === "user" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(user, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                user: user,
                                index: index
                            }, user.id);
                        })
                    }),
                    searchType === "hashtag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(searchedHashtag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagSearchedResultMobile, {
                                searchedHashtag: searchedHashtag
                            }, "SearchHashtagSection-".concat(searchedHashtag.name, "-").concat(index));
                        })
                    })
                ]
            })
        });
    }, []);
    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageMobile, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageDesktop, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    });
};
/* harmony default export */ var search_SearchPage = (SearchPage);

;// CONCATENATED MODULE: ./pages/search.tsx



var MENU_OPTIONS = [
    {
        title: "Ideas",
        key: "block"
    },
    {
        title: "People",
        key: "user"
    },
    {
        title: "Topics",
        key: "hashtag"
    },
    {
        title: "Sources",
        key: "article"
    }, 
];
var OWNER_OPTIONS = [
    {
        title: "All",
        key: "all"
    },
    {
        title: "Own",
        key: "own"
    }, 
];
var Search = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPage, {
        initialApiData: initialApiData !== null && initialApiData !== void 0 ? initialApiData : undefined,
        initialSearchType: initialSearchType !== null && initialSearchType !== void 0 ? initialSearchType : undefined
    });
};
// export const getServerSideProps: GetServerSideProps<OwnProps> = async ctx => {
//   const { q, owner, tab } = ctx.query;
//   const { token } = cookie.parse(ctx.req.headers.cookie ?? '');
//   if (!q) {
//     return {
//       props: {
//         initialApiData: null,
//         initialSearchType: null,
//       },
//     };
//   }
//   //Get rid of the # in the query
//   let parsedSearchText = q as string;
//   if (parsedSearchText.includes('#')) {
//     parsedSearchText = replaceAll(parsedSearchText, '#', '');
//   }
//   //Get the search type based on the query param
//   const searchType =
//     MENU_OPTIONS.find(
//       option => option.title.toLowerCase() === (tab as SearchType),
//     )?.key ?? 'block';
//   const res = await search(
//     parsedSearchText,
//     searchType,
//     owner as 'all' | 'own',
//     token,
//   );
//   return {
//     props: {
//       initialApiData: res ?? null,
//       initialSearchType: searchType,
//     },
//   };
// };
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldGet; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_extract_field_descriptor.mjs
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_apply_descriptor_get.mjs
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_get.mjs



function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}


/***/ }),

/***/ 70222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldInit; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_check_private_redeclaration.mjs
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_init.mjs


function _classPrivateFieldInit(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,9834,5611,2853,3244,9774,2888,179], function() { return __webpack_exec__(38420); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);